const options = [
    { id: 1, key: 'profile' },
    { id: 2, key: 'express' },
    { id: 3, key: 'error' },
    { id: 4, key: 'pleating' },
];

export function paintListTypeOptions() {
    return options.map((option) => ({
        id: option.id,
        key: option.key,
    }));
}

export function paintListTypeOptionById(id) {
    return options.find((option) => option.id === parseInt(id));
}
